import React from "react";
import styles from "./FormLayout.module.css";

interface FormLayoutProps {
  title: string;
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const FormLayout: React.FC<FormLayoutProps> = ({
  title,
  children,
  onSubmit,
}) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <form onSubmit={onSubmit} className={styles.form}>
        {children}
      </form>
    </div>
  );
};
